import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-group date-range" }
const _hoisted_2 = { class: "ws-nowrap" }
const _hoisted_3 = { class: "form-group road-name" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group direction" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "form-group kilopost-range" }
const _hoisted_8 = { class: "ws-nowrap" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "form-group car-number" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group tag-btn" }
const _hoisted_14 = {
  key: 0,
  class: "ib ml4"
}
const _hoisted_15 = { class: "form-group search-btn ta-center ws-nowrap" }
const _hoisted_16 = { class: "ib" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "badge badge-pill badge-success ml8 search-type-text"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-pill badge-warning ml8 search-type-text"
}

import type { Device } from 'src/models/device';
import { useReactiveMasters } from 'src/composables/useMasters';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';


export default /*@__PURE__*/_defineComponent({
  __name: 'MovieSearchBar',
  props: {
    devices: {}
  },
  setup(__props: any) {



const { masters } = useReactiveMasters();
const {
  movieSearch,
  isValidMovieSearchParams,
  isMovieSearchResultModeArea,
  isMovieSearchResultModeRoute,
  searchParamMovieSearchButtonTooltip,
  doSearchParamMovieSearch,
  onDateParamChange,
  onRoadNameDispChange,
  openTagModal,
} = useMovieSearchStore();

return (_ctx: any,_cache: any) => {
  const _component_MyCalendar = _resolveComponent("MyCalendar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("form", {
    class: "search-bar",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_unref(doSearchParamMovieSearch) && _unref(doSearchParamMovieSearch)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-control-label" }, "期間", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_MyCalendar, {
          class: "date-from",
          "date-value": _unref(movieSearch).params.dtFrom,
          "set-date-value-once": false,
          onDateInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(onDateParamChange)('from', $event)))
        }, null, 8, ["date-value"]),
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ib waveline ta-center" }, "〜", -1)),
        _createVNode(_component_MyCalendar, {
          class: "date-to",
          "date-value": _unref(movieSearch).params.dtTo,
          "set-date-value-once": false,
          onDateInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(onDateParamChange)('to', $event)))
        }, null, 8, ["date-value"])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "param-spacer" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-control-label" }, "路線名", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(movieSearch).params.roadNameDispObj) = $event)),
        class: "custom-select",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(onRoadNameDispChange)()))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masters).kp.roadNameDisps, (e, idx) => {
          return (_openBlock(), _createElementBlock("option", {
            key: idx,
            value: e
          }, _toDisplayString(e.roadNameDispShort), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, _unref(movieSearch).params.roadNameDispObj]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-control-label" }, "方向", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(movieSearch).params.direction) = $event)),
        class: "custom-select",
        disabled: !_unref(movieSearch).params.roadNameDispObj
      }, [
        _cache[14] || (_cache[14] = _createElementVNode("option", { value: '' }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(movieSearch).params.roadNameDispObj || {}).directions, (e, idx) => {
          return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(e), 1))
        }), 128))
      ], 8, _hoisted_6), [
        [_vModelSelect, _unref(movieSearch).params.direction]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-control-label" }, "キロポスト", -1)),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(movieSearch).params.kpCalcFrom) = $event)),
          type: "text",
          disabled: !_unref(movieSearch).params.direction,
          class: "ib form-control kp-calc-from"
        }, null, 8, _hoisted_9), [
          [_vModelText, _unref(movieSearch).params.kpCalcFrom]
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ib waveline ta-center" }, "〜", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(movieSearch).params.kpCalcTo) = $event)),
          type: "text",
          disabled: !_unref(movieSearch).params.direction,
          class: "ib form-control kp-calc-to"
        }, null, 8, _hoisted_10), [
          [_vModelText, _unref(movieSearch).params.kpCalcTo]
        ])
      ])
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "param-spacer" }, null, -1)),
    _createElementVNode("div", _hoisted_11, [
      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-control-label" }, "車両番号", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(movieSearch).params.carName) = $event)),
        class: "custom-select"
      }, [
        _cache[18] || (_cache[18] = _createElementVNode("option", { value: '' }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.devices, (e) => {
          return (_openBlock(), _createElementBlock("option", {
            key: e.deviceId,
            value: e.carName
          }, _toDisplayString(e.carName), 9, _hoisted_12))
        }), 128))
      ], 512), [
        [_vModelSelect, _unref(movieSearch).params.carName]
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "param-spacer" }, null, -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        class: "btn btn-secondary",
        type: "button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(openTagModal) && _unref(openTagModal)(...args)))
      }, [...(_cache[20] || (_cache[20] = [
        _createElementVNode("i", { class: "fas fa-tag" }, null, -1)
      ]))]),
      ((_unref(movieSearch).params.tags?.length ?? 0) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(movieSearch).params.tags, (e) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["tag-badge mr4", 'tag-badge-' + e.tagType1]),
                key: e.id
              }, _toDisplayString(e.tagName), 3))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary ib",
          disabled: !_unref(isValidMovieSearchParams)
        }, " 動画検索 ", 8, _hoisted_17)
      ])), [
        [
          _directive_tooltip,
          _unref(searchParamMovieSearchButtonTooltip),
          void 0,
          { top: true }
        ]
      ]),
      (_unref(isMovieSearchResultModeArea))
        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 範囲検索中 "))
        : _createCommentVNode("", true),
      (_unref(isMovieSearchResultModeRoute))
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, " ルート検索中 "))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})